import { RouteMatcher } from "./route-matcher";
export class AppRouteRouteMatcher extends RouteMatcher {
}

//# sourceMappingURL=app-route-route-matcher.js.map